import React from "react";

import { Badge, Col, Collapse, Row, Table, Typography } from "antd";
import { labelConfig } from "../../../customer.config";

const { Title, Text } = Typography;
const { Panel } = Collapse;

function AccountsOverview(props) {
  const { loansList, savingsList } = props;

  const loanColumns = [
    {
      title: "Account Number",
      dataIndex: "accountNo",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Original Loan",
      dataIndex: "originalLoan",
    },
    {
      title: "Amount Paid",
      dataIndex: "amountPaid",
    },
    {
      title: "Loan Type",
      dataIndex: "loanType",
    },
    {
      title: " Loan Balance",
      dataIndex: "loanBalance",
    },
  ];

  const casaColumns = [
    {
      title: "Account Number",
      dataIndex: "accountNo",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Last Active",
      dataIndex: "lastActive",
    },
    {
      title: "Available Balance",
      dataIndex: "availableBalance",
      key: "actions",
    },
  ];

  const fixedDepositColumns = [
    {
      title: "Account Number",
      dataIndex: "accountNo",
    },

    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Maturity Date",
      dataIndex: "maturityDate",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Available Balance",
      dataIndex: "availableBalance",
      key: "actions",
    },
  ];

  const RecurringepositColumns = [
    {
      title: "Account Number",
      dataIndex: "accountNo",
    },

    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Maturity Date",
      dataIndex: "maturityDate",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Available Balance",
      dataIndex: "availableBalance",
      key: "actions",
    },
  ];

  const cardsColumns = [
    {
      title: "Card Type",
      dataIndex: "cardType",
    },

    {
      title: "Card Number (Masked)",
      dataIndex: "cardNumber",
    },
    {
      title: "Expiry Date",
      dataIndex: "expiryDate",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
  ];

  const walletColumns = [
    {
      title: "Account Number",
      dataIndex: "accountNumber",
    },

    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
  ];

  const interbankColumns = [
    {
      title: "Account Number",
      dataIndex: "accountNumber",
    },

    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
  ];

  const bondsColumns = [
    {
      title: "Account Number",
      dataIndex: "accountNumber",
    },

    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
  ];

  const treasuryColumns = [
    {
      title: "Account Number",
      dataIndex: "accountNumber",
    },

    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
  ];

  const handleAccountType = (keyParam) => {
    switch (keyParam.toLowerCase()) {
      case "current":
        // depositType.id = 100 AND allowOverdraft = true
        return savingsList.filter(
          (item) =>
            item?.depositType?.id === 100 && item?.allowOverdraft === true
        );
      case "savings":
        return savingsList.filter(
          (item) =>
            item?.depositType?.id === 100 && item?.allowOverdraft === false
        );
      case "fixed deposit":
        return savingsList.filter((item) => item?.depositType?.id === 200);
      case "recurring deposit":
        return savingsList.filter((item) => item?.depositType?.id === 300);
      case "loans":
        return loansList;
      default:
        return [];
    }
  };

  const handlePanelHeader = (typeParam, labelParam1, labelParam2) => {
    return (
      <Badge count={handleAccountType(typeParam).length}>
        <Title level={5} style={{ margin: 3 }}>
          {handleAccountType(typeParam).length <= 1 ? labelParam1 : labelParam2}
        </Title>
      </Badge>
    );
  };

  return (
    <Row>
      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={handlePanelHeader(
              "current",
              labelConfig.currentAccount,
              labelConfig.currentAccounts
            )}
            key="1"
          >
            <Table
              columns={casaColumns}
              dataSource={handleAccountType("current")}
            />
          </Panel>
        </Collapse>
      </Col>
      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={handlePanelHeader(
              "savings",
              labelConfig.savingsAccount,
              labelConfig.savingsAccounts
            )}
            key="1"
          >
            <Table
              columns={casaColumns}
              dataSource={handleAccountType("savings")}
            />
          </Panel>
        </Collapse>
      </Col>

      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={handlePanelHeader(
              "loans",
              labelConfig.loansAccount,
              labelConfig.loansAccounts
            )}
            key="1"
          >
            <Table
              columns={loanColumns}
              dataSource={handleAccountType("loans")}
            />
          </Panel>
        </Collapse>
      </Col>

      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={handlePanelHeader(
              "fixed deposit",
              labelConfig.fixedDepositAccount,
              labelConfig.fixedDepositAccounts
            )}
            key="1"
          >
            <Table
              columns={fixedDepositColumns}
              dataSource={handleAccountType("fixed deposit")}
            />
          </Panel>
        </Collapse>
      </Col>

      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={handlePanelHeader(
              "recurring deposit",
              labelConfig.recurringDepositAccount,
              labelConfig.recurringDepositAccounts
            )}
            key="1"
          >
            <Table
              columns={RecurringepositColumns}
              dataSource={handleAccountType("recurring deposit")}
            />
          </Panel>
        </Collapse>
      </Col>
      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={
              <Title level={5} style={{ margin: 0 }}>
                {labelConfig.cardInfo}
              </Title>
            }
            key="1"
          >
            <Table columns={cardsColumns} />
          </Panel>
        </Collapse>
      </Col>

      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={
              <Title level={5} style={{ margin: 0 }}>
                {labelConfig.walletInfo}
              </Title>
            }
            key="1"
          >
            <Table columns={walletColumns} />
          </Panel>
        </Collapse>
      </Col>
      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={
              <Title level={5} style={{ margin: 0 }}>
                {labelConfig.interbankInfo}
              </Title>
            }
            key="1"
          >
            <Table columns={interbankColumns} />
          </Panel>
        </Collapse>
      </Col>
      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={
              <Title level={5} style={{ margin: 0 }}>
                {labelConfig.bondsInfo}
              </Title>
            }
            key="1"
          >
            <Table columns={bondsColumns} />
          </Panel>
        </Collapse>
      </Col>
      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={
              <Title level={5} style={{ margin: 0 }}>
                {labelConfig.treasuryInfo}
              </Title>
            }
            key="1"
          >
            <Table columns={treasuryColumns} />
          </Panel>
        </Collapse>
      </Col>
    </Row>
  );
}

export default AccountsOverview;
